<template>
  <div>
    <v-container grid-list-xl class="word-wrap mt-5">
      <v-layout row wrap justify-center mt-5>
        <v-list
          subheader
          two-line
          width="600"
          style="background-color: transparent !important"
        >
          <div
            v-for="(item, index) in data"
            :key="item.Id.concat(index.toString())"
          >
            <user-list-item
              :item="item"
              @sendMessage="(n) => sendMessage(n)"
              :buttonVisible="buttonVisible(item)"
              :buttonText="buttonText(item)"
              :buttonDisabled="buttonDisabled(item)"
              :avatar=item.Avatar
              :fullName=getFullName(item)
              :department=item.Department
              :userId=item.Id
              :company=item.Company
            />
          </div>
          <loading-progress :status="loadMoreLoading" />
        </v-list>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import ContentService from "@/services/ContentService";
import LoadingProgress from "../../components/General/LoadingProgress.vue";
import UserListItem from "../../components/Users/UserListItem.vue";
import NotificationService from "../.././services/NotificationService";
import { mapActions } from "vuex";
export default {
  data: () => {
    return {
      page: 1,
      pageSize: 30,
      data: [],
      noData: false,
      loadMoreLoading: false,
      paginationStop: false,

      today: new Date().setHours(0, 0, 0, 0),
      sended: [],
    };
  },
  components: {
    LoadingProgress,
    UserListItem,
  },
  methods: {
    getSended() {
      const _sended = this.$store.state.sendedBornTodayUsers;
      if (!!_sended) this.sended = _sended;

      //Her yıl butonun tekrar aktif olması için
      if (
        !!_sended &&
        new Date(_sended.date).getTime() === this.today
      ) {
        this.sended = _sended;
      } else {
        this.setSended({ sendKey: "sendedBornTodayUsers", value: [] });
      }
      console.log('senden 1:' , this.sended)
      this.getContent();
    },

    getContent() {
      this.page == 1 ? setPageLoading(true) : (this.loadMoreLoading = true);

      ContentService.getBornToday(this.page, this.pageSize)
        .then((res) => {
          if (res.data.length == 0) this.paginationStop = true;
          if (this.page != 1) {
            this.data = [...this.data, ...res.data];
          } else {
            this.data = res.data;
          }
          if (res.data.length <= 0) {
            this.noData = true;
          }
        })
        .catch((err) => {
          showError(err);
        })
        .then(() => {
          this.page == 1
            ? setPageLoading(false)
            : (this.loadMoreLoading = false);
        });
    },

    sendMessage(item) {
      NotificationService.sendNotification(
        item.Username,
        "bugun_doganlar"
      )
        .then((res) => {
          showSuccess(this.$t("description.sendedNotification"));
          this.setLocaleStore(item);
        })
        .catch((err) => {
          console.log("err", err.response.data);
          showError(err);
        });
    },

    setLocaleStore(item) {
      //Önce store a tebrik edilenin bilgisi atılıyor ki uygulama hafızasında kalsın tekrar tekrar kutlama yapamasın.
      //Kutlama yaptığı tarih ekleniyor ki her sene buton tekrar aktif olsun. (Bugün doğanlar için)

      let _array = this.sended;
      item.date = this.today;
      _array.push(item);

      this.setSended({
        sendKey: "sendedBornTodayUsers",
        value: _array,
      });
      this.sended = _array;
      console.log('senden 2:' , this.sended)
      this.buttonDisabled(item);
    },

    buttonText(item) {
      const sended =
        this.sended.find((i) => i.Id === item.Id) ||
        this.$store.state.user.Id === item.Id;
      if (sended) {
        return this.$t('buttons.celebrated');
      } else {
        return this.$t('buttons.celebrate');
      }
    },

    buttonDisabled(item) {
      const sended =
        this.sended.find((i) => i.Id === item.Id) ||
        this.$store.state.user.Id === item.Id;
      if (sended) {
        return true;
      } else {
        return false;
      }
    },

    buttonVisible(item) {
      const sended = this.$store.state.user.Id == item.Id;
      if (sended) {
        return false;
      } else {
        return true;
      }
    },

    //Infinite scroll
    scrollTop(e) {
      //Yeni doğanlar servisinde pagination yapısı olmadığı için sistem kapatıldı
      if (!this.loadMoreLoading) {
        if (
          window.innerHeight + window.scrollY >=
          document.body.offsetHeight - 100
        ) {
          //if (!this.paginationStop) this.paginationPage();
        }
      }
    },

    paginationPage() {
      this.page++;
      this.getContent();
    },

    getFullName(item) {
      return item.FirstName + ' ' + item.LastName
    },

    ...mapActions(["setSended"]),
  },
  computed: {

  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollTop);
  },
  mounted() {
    this.getSended();
    window.addEventListener("scroll", this.scrollTop);
  },
  watch: {},
};
</script>

<style></style>
